<section id="hero">
  <swiper
    #swiper
    [slidesPerView]="1"
    [centeredSlides]="true"
    [loop]="true"
    [navigation]="{
      prevEl: '.heroSlidePrev',
      nextEl: '.heroSlideNext'
    }"
  >
    <ng-template swiperSlide *ngFor="let slide of slidesStore; index as i">
      <img
        class="nomobile"
        [src]="slide.src"
        [alt]="slide.alt"
        [title]="slide.title"
      />
      <div
        class="mobile bgimg"
        [ngStyle]="{ 'background-image': 'url(' + slide.mobilesrc + ')' }"
      ></div>
      <div class="carouselCTA">
        <a href="{{ slide.CTALink }}" class="button primary scrolly">{{
          slide.CTALabel
        }}</a>
      </div>
      <div class="carouselCTA2" [hidden]="!slide.CTALabel2">
        <a href="{{ slide.CTALink2 }}" class="button primary scrolly">{{
          slide.CTALabel2
        }}</a>
      </div>
    </ng-template>
  </swiper>
  <div class="heroSlideAction">
    <a class="heroSlidePrev"><img src="./assets/images/prev.svg" /></a
    ><a class="heroSlideNext"><img src="./assets/images/next.svg" /></a>
  </div>
</section>

<!-- Banner -->
<!--
<section id="banner">
  <div class="content">
    <header>
      <h2>Five ASide Theatre CIC</h2>
      <p>
        Let’s Play The Play, <br />
        Truth As A Game.
      </p>
    </header>
    <span class="image"
      ><img src="./assets/images/transparent background_Five.png" alt=""
    /></span>
  </div>
  <a href="#one" class="goto-next home scrolly">Next</a>
</section>
-->

<!-- One -->
<section id="one" class="spotlight styleYellow bottom">
  <span class="image fit main"
    ><img src="./assets/images/bg-logo.png" alt=""
  /></span>
  <div class="content">
    <div class="container FASTyellow">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <h2 class="FASTyellow">Five ASide Theatre CIC</h2>
            <p>Information</p>
            <span class="image fit main">
              <img src="./assets/images/transparent background_Four.png" />
            </span>
          </header>
        </div>
        <div class="col-4 col-12-medium">
          <p>
            Five A Side Theatre is a theatre performance game / devising system
            that explores the truth(s) of an issue from several perspectives.
          </p>
          <p>
            Inspired by Hip Hop Freestyle battles, politicisation of Brecht’s
            Epic Theatre, the structured improvisation of a travelling Commedia
            Dell’Arte troupe, ensemble devising of DV8, Frantic Assembly and
            Verbatim theatre F.AS.T. creates compelling contemporary narratives.
          </p>
          <p>
            Five ASide Theatre explores the conflicting perspectives of an issue
            encouraging the audience to debate whose truth they believe.
          </p>
        </div>
        <div class="col-4 col-12-medium">
          <p>
            Exploring personal/community narratives from a range of perspectives
            develops our understanding of the way communities and societies
            function at a variety of levels.
          </p>
          <p>
            Five ASide Theatre develops audience members understanding and
            appreciation of the wide range of cultural influences that have
            shaped their own perspectives.
          </p>
        </div>
      </div>
    </div>
  </div>
  <a href="#two" class="goto-next scrolly">Next</a>
</section>

<!-- Two -->
<section id="two" class="spotlight styleYellow bottom">
  <span class="image fit main"
    ><img src="./assets/images/bg-logo.png" alt=""
  /></span>
  <div class="content">
    <div class="container FASTyellow">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <h2>
              Five ASide Theatre Summer Academy<br />
              (9-16 YEARS)
            </h2>

            <h3>FAQs</h3>
          </header>
        </div>
        <div class="col-4 col-12-medium">
          <button class="accordion">
            What is Five ASide Theatre Summer Academy? (part 1)
          </button>
          <div class="panel">
            <p>
              Five ASide Theatre CIC are inviting children aged 12-16 to join
              them this summer for a week of theatrical fun, games, trophies and
              medals. During the academy players will be split into Five ASide
              Theatre Teams to compete in Theatre and Sports Games. All genders
              and abilities welcome.
            </p>
            <p>
              Led by experienced Drama teachers, Directors, Coaches, Drama
              facilitators (all adults DBS checked), the young performers will
              have the chance to be part of a professional theatre company for a
              week, while building confidence, boosting social skills and
              sparking imagination.
            </p>
          </div>

          <button class="accordion">
            What is Five ASide Theatre Summer Academy? (part 2)
          </button>
          <div class="panel">
            <p>
              We will provide fun through a variety of exciting games and drama
              activities covering storytelling, physical theatre, rapping,
              sports and more!
            </p>
            <p>
              Young performers will gain hands-on experience and work as a team
              to develop stories for culminating in ab awards ceremony on the
              final day.
            </p>
            <p>
              Please ensure players are prepared for a full day of activity.
              This includes a water bottle, face mask if they’re travelling on
              public transport, sunscreen, mosquito repellent. However we will
              provide these if your child doesn’t have them.
            </p>
          </div>

          <button class="accordion">
            Where is this Summer’s Academy Located?
          </button>
          <div class="panel">
            <p>
              The Summer Academy will be held at St. John Fisher Primary School,
              Grand Drive, SW90 9NA
            </p>
            <p>
              You’re permitted to drop off your child in the car park but there
              is no on-site parking.
            </p>
          </div>

          <button class="accordion">
            When will this Summer’s Academy occur?
          </button>
          <div class="panel">
            <p>
              Premier league : Monday 16th to Friday 20th August (last few
              spaces remaining)
            </p>
          </div>

          <button class="accordion">
            What are the start and end times for this season’s academy?
          </button>
          <div class="panel">
            <p>The summer Academy will run 9.00am-3.00pm each day.</p>
          </div>

          <button class="accordion">
            Who’s eligible to take place in this Summer’s academy?
          </button>
          <div class="panel">
            <p>
              This Summer Academy is for Free for Free School Meals children
              with proof of benefit, aged 12-16 (or having completed school
              years 7-10).
            </p>
          </div>
        </div>
        <div class="col-4 col-12-medium">
          <button class="accordion">
            How many places do you have in this Summer’s Academy?
          </button>
          <div class="panel">
            <p>The Summer Academy is limited to 25 players.</p>
          </div>

          <button class="accordion">Do you provide Lunch?</button>
          <div class="panel">
            <p>Meals will be provided to all players throughout the week.</p>
          </div>

          <button class="accordion">
            How do we register for the Five ASide Theatre Summer Academy?
          </button>
          <div class="panel">
            <p>
              Please complete the attached registration form and attach proof of
              your Free School Meals entitlement.
            </p>
            <p>
              Submission of a registration form does not guarantee a place. We
              will be in touch as soon as possible after submission to let you
              know if we can offer your child a place. Places are confirmed upon
              receipt of a confirmation email.
            </p>
          </div>

          <button class="accordion">Are the Coaches qualified?</button>
          <div class="panel">
            <p>
              Coaches have training in Safeguarding, First Aid, Running Safe
              Activities and Theatre experience. Five ASide Theatre is committed
              to all aspects of safeguarding. All adults at the Summer School
              will have an enhanced DBS check, with a Designated Safeguarding
              Lead and First Aider on site each day.
            </p>
          </div>

          <button class="accordion">
            What provisions do you have for being Covid-19 secure?
          </button>
          <div class="panel">
            <p>
              If restrictions are still in place in August, we will be following
              official government guidance for the running of holiday and
              after-school activities, and parents/guardians will be notified of
              our procedures.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#four" class="goto-next scrolly">Next</a>
</section>

<!-- Four -->
<section id="four" class="wrapper style2 special fade application">
  <div class="container">
    <header>
      <h2>Application link</h2>
      <p>Apply to be a Five ASide Theatre Player in our Summer Academy</p>
    </header>

    <form [formGroup]="personalDetails">
      <!-- progressbar -->
      <div class="nomobile progress-container col-12 col-12-medium">
        <ul id="progressbar" class="progressbar">
          <li [ngClass]="step >= 1 ? 'active ' : 'inactive'">
            Personal Detailsy
          </li>
          <li [ngClass]="step >= 2 ? 'active' : 'inactive'">dates Attending</li>
          <li [ngClass]="step >= 3 ? 'active' : 'inactive'">
            Parent/Carer Details
          </li>
          <li [ngClass]="step >= 4 ? 'active ' : 'inactive'">
            Personal Contact Details
          </li>
          <li [ngClass]="step >= 5 ? 'active' : 'inactive'">
            Alternative Contact Details
          </li>
          <li [ngClass]="step >= 6 ? 'active' : 'inactive'">Medical Details</li>
          <li [ngClass]="step >= 7 ? 'active' : 'inactive'">
            Additional Details
          </li>
          <li [ngClass]="step >= 8 ? 'active' : 'inactive'">Complete</li>
        </ul>
      </div>

      <div class="mobile progress-container col-12 col-12-medium">
        <ul id="progressbar" class="progressbar">
          <li
            [hidden]="step == 1 || step == 1 + 1 || step == 1 - 1"
            [ngClass]="step >= 1 ? 'active ' : 'inactive'"
          >
            <!--Personal Details-->
          </li>
          <li
            [hidden]="step == 2 || step == 2 + 1 || step == 2 - 1"
            [ngClass]="step >= 2 ? 'active' : 'inactive'"
          >
            <!--dates Attending-->
          </li>
          <li
            [hidden]="step == 3 || step == 3 + 1 || step == 3 - 1"
            [ngClass]="step >= 3 ? 'active' : 'inactive'"
          >
            <!--Parent/Carer Details-->
          </li>
          <li
            [hidden]="step == 4 || step == 4 + 1 || step == 4 - 1"
            [ngClass]="step >= 4 ? 'active ' : 'inactive'"
          >
            <!--Personal Contact Details-->
          </li>
          <li
            [hidden]="step == 5 || step == 5 + 1 || step == 5 - 1"
            [ngClass]="step >= 5 ? 'active' : 'inactive'"
          >
            <!--Alternative Contact Details-->
          </li>
          <li
            [hidden]="step == 6 || step == 6 + 1 || step == 6 - 1"
            [ngClass]="step >= 6 ? 'active' : 'inactive'"
          >
            <!--Medical Details-->
          </li>
          <li
            [hidden]="step == 7 || step == 7 + 1 || step == 7 - 1"
            [ngClass]="step >= 7 ? 'active' : 'inactive'"
          >
            <!--Additional Details-->
          </li>
          <li
            [hidden]="step == 8 || step == 8 + 1 || step == 8 - 1"
            [ngClass]="step >= 8 ? 'active' : 'inactive'"
          >
            <!--Complete-->
          </li>
        </ul>
      </div>

      <div class="col-12 col-12-medium clearfix">
        <!-- fieldsets -->
        <fieldset *ngIf="step == 1">
          <h2 class="fs-title">Personal Details</h2>
          <div class="row">
            <div class="col-4 off-4 col-10-small off-1-small">
              <input
                type="text"
                formControlName="name"
                [ngClass]="{
                  'is-invalid': personal_step && personal.name.errors
                }"
                placeholder="Full Name"
              />
              <div
                *ngIf="personal_step && personalDetails.controls.name.errors"
              >
                <div *ngIf="personal.name.errors?.required">
                  Name is required
                </div>
              </div>
              <dp-date-picker
                formControlName="dob"
                placeholder="Date of Birth"
                #dayPicker
              ></dp-date-picker>
              <!--
          <button (click)="open()">Pick Date of Birth</button> 
          <button (click)="close()">Close</button>
          -->

              <div *ngIf="personal_step && personalDetails.controls.dob.errors">
                <div *ngIf="personal.dob.errors?.required">DOB is required</div>
              </div>

              <input
                type="text"
                formControlName="address"
                name="address"
                placeholder="Address"
              />
              <div
                *ngIf="personal_step && personalDetails.controls.address.errors"
              >
                <div *ngIf="personal.address.errors?.required">
                  Address is required
                </div>
              </div>
              <input
                (click)="next()"
                type="button"
                name="next"
                class="next action-button"
                value="Next"
              />
            </div>
          </div>
        </fieldset>
      </div>
    </form>

    <form [formGroup]="datesAttendingDetails">
      <fieldset *ngIf="step == 2">
        <h2 class="fs-title">Dates Attending</h2>
        <div class="row">
          <div class="col-4 off-3 off-1-small">
            <label class="form-container"
              >All Dates
              <input
                type="checkbox"
                formControlName="alldates"
                checked="checked"
              />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Monday 16th
              <input type="checkbox" formControlName="monday16th" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Tuesday 17th
              <input type="checkbox" formControlName="tuesday17th" />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col-4">
            <label class="form-container"
              >Wednesday 18th
              <input type="checkbox" formControlName="wednesday18th" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Thursday 19th
              <input type="checkbox" formControlName="thursday19th" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Friday 20th
              <input type="checkbox" formControlName="frisday20th" />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <input
          (click)="previous()"
          type="button"
          name="previous"
          class="previous action-button-previous"
          value="Previous"
        />
        <input
          (click)="next()"
          type="button"
          name="next"
          class="next action-button"
          value="Next"
        />
      </fieldset>
    </form>

    <form class="applicationForm" [formGroup]="parentCarerDetails">
      <fieldset *ngIf="step == 3">
        <h2 class="fs-title">Parent Carer Name</h2>
        <div class="row">
          <div class="col-6 col-10-small off-1-small">
            <input
              type="text"
              formControlName="parentCarerName"
              name="parentCarerName"
              placeholder="parentCarerName"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.parentCarerName.errors
              "
            >
              <div *ngIf="parentCarer.parentCarerName.errors?.required">
                Parent Carer Name is required
              </div>
            </div>

            <input
              type="text"
              formControlName="relationshipToYP"
              name="relationshipToYP"
              placeholder="Relationship To Young Person"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.relationshipToYP.errors
              "
            >
              <div *ngIf="parentCarer.relationshipToYP.errors?.required">
                Relationship To Young Person is required
              </div>
            </div>

            <input
              type="text"
              formControlName="parentCarerAddress"
              name="parentCarerAddress"
              placeholder="parent Carer Address"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.parentCarerAddress.errors
              "
            >
              <div *ngIf="parentCarer.parentCarerAddress.errors?.required">
                parent Carer Address is required
              </div>
            </div>
          </div>
          <div class="col-6 col-10-small off-1-small">
            <input
              type="text"
              formControlName="parentCarerHomeTel"
              name="parentCarerHomeTel"
              placeholder="Parent Carer Home Tel"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.parentCarerHomeTel.errors
              "
            >
              <div *ngIf="parentCarer.parentCarerHomeTel.errors?.required">
                Parent Carer Home Tel is required
              </div>
            </div>

            <input
              type="text"
              formControlName="parentCarerMobileTel"
              name="parentCarerMobileTel"
              placeholder="Parent Carer Mobile Tel"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.parentCarerMobileTel.errors
              "
            >
              <div *ngIf="parentCarer.parentCarerMobileTel.errors?.required">
                Parent Carer Mobile Tel is required
              </div>
            </div>

            <input
              type="text"
              formControlName="parentCarerEmail"
              name="parentCarerEmail"
              placeholder="Parent Carer Email"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.parentCarerEmail.errors
              "
            >
              <div *ngIf="parentCarer.parentCarerEmail.errors?.required">
                Parent Carer Email is required
              </div>
            </div>

            <!--
            <input
              type="file"
              accept="image/*" 
              (change)="imagePreview($event)"
              formControlName="parentFreeMeals"
              name="parentFreeMeals"
              placeholder="Parent/Carer Free Meal Evidence"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.parentFreeMeals.errors
              "
            >
              <div *ngIf="parentCarer.parentFreeMeals.errors?.required">
                Parent/Carer Free Meal Evidence is required
              </div>
            </div>
          --></div>
        </div>

        <h3>
          Please provide evidence of your free school meals entitlement. We will
          accept
        </h3>
        <ul>
          <li>
            A letter from your secondary school indicating your Free school
            meals entitlement.
          </li>
          <li>
            Attach a photo Your Universal Credit award letter to this
            registration.
          </li>
          <li>
            Attach a screen shot of your free school meals benefits entitlement
            to this registration
          </li>
        </ul>
        <div
          class="dropdiv"
          [class.processing]="processing"
          (dragover)="onDragOver($event)"
          (drop)="onDropSuccess($event)"
        >
          <label class="custom-file-upload">
            <input
              (change)="onChange($event)"
              formControlName="parentFreeMeals"
              type="file"
            />
            
          </label>
        </div>

        <div class="progress" [class.processing]="processing">
          Processing...
        </div>

        <div *ngIf="filePath && filePath !== ''">
          <img [src]="filePath" [alt]="parentCarerDetails.value.name" />
        </div>

        <input
          (click)="previous()"
          type="button"
          name="previous"
          class="previous action-button-previous"
          value="Previous"
        />
        <input
          (click)="next()"
          type="button"
          name="next"
          class="next action-button"
          value="Next"
        />
      </fieldset>
    </form>

    <form [formGroup]="contactDetails">
      <fieldset *ngIf="step == 4">
        <h2 class="fs-title">Personal Contact Details</h2>
        <div class="row">
          <div class="col-4 off-4 col-10-small off-1-small">
            <input
              type="text"
              formControlName="homeTel"
              name="homeTel"
              placeholder="homeTel"
            />
            <div *ngIf="contact_step && contactDetails.controls.homeTel.errors">
              <div *ngIf="contact.homeTel.errors?.required">
                home tel is required
              </div>
            </div>

            <input
              type="text"
              formControlName="mobileTel"
              name="mobileTel"
              placeholder="mobileTel"
            />
            <div
              *ngIf="contact_step && contactDetails.controls.mobileTel.errors"
            >
              <div *ngIf="contact.mobileTel.errors?.required">
                mobile tel is required
              </div>
            </div>

            <input
              type="text"
              formControlName="email"
              name="email"
              placeholder="email"
            />
            <div *ngIf="contact_step && contactDetails.controls.email.errors">
              <div *ngIf="contact.email.errors?.required">
                email is required
              </div>
            </div>
          </div>
        </div>
        <input
          (click)="previous()"
          type="button"
          name="previous"
          class="previous action-button-previous"
          value="Previous"
        />
        <input
          (click)="next()"
          type="button"
          name="next"
          class="next action-button"
          value="Next"
        />
      </fieldset>
    </form>

    <form [formGroup]="altContactDetails">
      <fieldset *ngIf="step == 5">
        <h2 class="fs-title">Alternative Contact Details</h2>
        <div class="row">
          <div class="col-4 off-4 col-10-small off-1-small">
            <input
              type="text"
              formControlName="altCarerHomeTel"
              name="altCarerHomeTel"
              placeholder="alt Carer Home Tel"
            />
            <div
              *ngIf="
                altContact_step &&
                altContactDetails.controls.altCarerHomeTel.errors
              "
            >
              <div *ngIf="altContact.altCarerHomeTel.errors?.required">
                alt Carer Home Tel is required
              </div>
            </div>

            <input
              type="text"
              formControlName="altCarerMobileTel"
              name="altCarerMobileTel"
              placeholder="Alt Carer Mobile Tel"
            />
            <div
              *ngIf="
                altContact_step &&
                altContactDetails.controls.altCarerMobileTel.errors
              "
            >
              <div *ngIf="altContact.altCarerMobileTel.errors?.required">
                Alt Carer Mobile Tel is required
              </div>
            </div>

            <input
              type="text"
              formControlName="altCarerEmail"
              name="altCarerEmail"
              placeholder="Alt Carer Email"
            />
            <div
              *ngIf="
                altContact_step &&
                altContactDetails.controls.altCarerEmail.errors
              "
            >
              <div *ngIf="altContact.altCarerEmail.errors?.required">
                Alt Carer Email is required
              </div>
            </div>
          </div>
        </div>

        <input
          (click)="previous()"
          type="button"
          name="previous"
          class="previous action-button-previous"
          value="Previous"
        />
        <input
          (click)="next()"
          type="button"
          name="next"
          class="next action-button"
          value="Next"
        />
      </fieldset>
    </form>

    <form [formGroup]="medicalDetails">
      <fieldset *ngIf="step == 6">
        <h2 class="fs-title">Medical Details</h2>
        <div class="row">
          <div class="col-4 off-3 off-1-small">
            <label class="form-container"
              >asthma Brochitis
              <input
                type="checkbox"
                formControlName="asthmaBrochitis"
                checked="checked"
              />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Allergies
              <input type="checkbox" formControlName="allergies" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >ADHD
              <input type="checkbox" formControlName="ADHD" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Diabetes
              <input type="checkbox" formControlName="Diabetes" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >HCFFB
              <input type="checkbox" formControlName="HCFFB" />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col-4">
            <label class="form-container"
              >hayfever
              <input type="checkbox" formControlName="hayfever" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >headaches
              <input type="checkbox" formControlName="headaches" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >currentMT
              <input type="checkbox" formControlName="currentMT" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >other
              <input type="checkbox" formControlName="other" />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <input
          (click)="previous()"
          type="button"
          name="previous"
          class="previous action-button-previous"
          value="Previous"
        />
        <input
          (click)="next()"
          type="button"
          name="next"
          class="next action-button"
          value="Next"
        />
      </fieldset>
    </form>

    <form [formGroup]="additionalDetails">
      <fieldset *ngIf="step == 7">
        <h2 class="fs-title">Additional Details</h2>

        <div class="row">
          <div class="col-4 off-4 col-10-small off-1-small">
            <input
              type="text"
              formControlName="diet"
              name="diet"
              placeholder="diet"
            />
            <!--
        <div *ngIf="additional_step && additionalDetails.controls.diet.errors">
          <div *ngIf="additional.diet.errors?.required">
            diet is required
          </div>
        </div>
        -->

            <input
              type="text"
              formControlName="disibility"
              name="disibility"
              placeholder="disibility"
            />
            <!--
        <div *ngIf="additional_step && additionalDetails.controls.disibility.errors">
          <div *ngIf="additional.disibility.errors?.required">
            disibility is required
          </div>
        </div>
        -->

            <input
              type="text"
              formControlName="familyDoctor"
              name="familyDoctor"
              placeholder="familyDoctor"
            />
            <!--
        <div *ngIf="additional_step && additionalDetails.controls.familyDoctor.errors">
          <div *ngIf="additional.familyDoctor.errors?.required">
            familyDoctor is required
          </div>
        </div>
        -->

            <input
              type="text"
              formControlName="familyDoctorTel"
              name="familyDoctorTel"
              placeholder="familyDoctorTel"
            />
            <!--
        <div *ngIf="additional_step && additionalDetails.controls.familyDoctorTel.errors">
          <div *ngIf="additional.familyDoctorTel.errors?.required">
            familyDoctorTel is required
          </div>
        </div>
        -->

            <input
              type="text"
              formControlName="freeMealEvidence"
              name="freeMealEvidence"
              placeholder="freeMealEvidence"
            />
            <!--
        <div *ngIf="additional_step && additionalDetails.controls.freeMealEvidence.errors">
          <div *ngIf="additional.freeMealEvidence.errors?.required">
            freeMealEvidence is required
          </div>
        </div>
        -->
          </div>
        </div>
        <input
          (click)="previous()"
          type="button"
          name="previous"
          class="previous action-button-previous"
          value="Previous"
        />
        <input
          (click)="next()"
          type="button"
          name="next"
          class="next action-button"
          value="Next"
        />
      </fieldset>
    </form>
    <form [formGroup]="signatureDetails" (ngSubmit)="onSubmit()">
      <fieldset *ngIf="step == 8">
        <h2 class="fs-title">Parent / Carer Signature</h2>

        <div class="row">
          <div class="col-4 off-4 col-10-small off-1-small">
            <div class="signature-container">
              <signature-pad
                [options]="signaturePadOptions"
                (onBeginEvent)="drawStart()"
                (onEndEvent)="drawComplete()"
              ></signature-pad>
            </div>

            <div class="buttons">
              <input
                (click)="clearSignature()"
                type="button"
                name="previous"
                value="Clear signature pad"
              />

              <input
                (click)="savePad()"
                type="button"
                name="previous"
                value="Save Signature"
              />
            </div>

            <div class="signature-image" *ngIf="signatureImg2">
              <!--<img src="{{ signatureImg }}" />-->
              SIGNATURE SAVED
            </div>
          </div>
        </div>

        <input
          (click)="previous()"
          type="button"
          name="previous"
          class="previous action-button-previous"
          value="Previous"
        />
        <input
          type="submit"
          name="submit"
          class="submit action-button"
          value="Submit"
        />
      </fieldset>
    </form>
  </div>
  <a href="#getdirections" class="goto-next scrolly">Next</a>
</section>

<!-- Four -->
<section id="getdirections" class="wrapper style1 special fade-up">
  <div class="container">
    <header class="major">
      <h2>Map and Directions</h2>
      <p>
        Map and directions Map and directions Map and directions Map and
        directions Map and directions
      </p>
    </header>
    <div class="box alt">
      <div class="row gtr-uniform">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4978.941052113106!2d-0.23013889789582448!3d51.39440858791216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8cbc4d080b61633b!2sSt%20John%20Fisher%20R%20C%20Primary%20School!5e0!3m2!1sen!2suk!4v1627670242753!5m2!1sen!2suk"
          width="100%"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
    <footer class="major">
      <ul class="actions special">
        <li>
          <a href="geo:51.394362,-0.225872&z=15&t=m&hl=en&gl=GB" class="button"
            >Open map for directions</a
          >
        </li>
      </ul>
    </footer>
  </div>
</section>
